export default {"src":"/_next/static/media/account.668fee49.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};